export enum enmSortDirection {
    Ascending = 1,
    Descending = 2
}